import type { IndicatorProps } from "@mantine/core";
import { Indicator } from "@mantine/core";
import classes from "./avatar-styles.module.css";

interface QueuedChatIndicatorProps extends IndicatorProps {
    size: number;
    visible: boolean;
}

export const QueuedChatIndicator = ({ children, visible, size, ...rest }: QueuedChatIndicatorProps) => {
    if (!visible) {
        return <>{children}</>;
    }

    return (
        <Indicator
            classNames={{
                indicator: classes.avatar_indicator,
                root: classes.avatar_indicator_root,
            }}
            inline
            withBorder
            {...rest}
            size={size}
            offset={8}
            position="top-end"
        >
            {children}
        </Indicator>
    );
};
